'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectOkvedTableDirective from "./directive/projectOkvedTable";

export default angular.module('investmentProject.project.okved', [])
    .directive('projectOkvedTable', ProjectOkvedTableDirective)
    .name;